// @flow

import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import { applyMiddleware, compose, createStore } from 'redux';
import { BrowserRouter, Switch } from 'react-router-dom';
import { loadTranslations, setLocale, syncTranslationWithStore } from 'react-redux-i18n';
import thunk from 'redux-thunk';
import 'react-app-polyfill/ie9'; // For IE 9-11 support
import 'react-app-polyfill/ie11'; // For IE 11 support
import '@westfieldcorp/font-awesome-5/src/lib/css/all.min.css';

import App from './App';
import en from './i18n/locales/en';
import reducers from './state/reducers';
import './sass/app.scss';
import PrivateRoute from './components/PrivateRoute';
import googleAnalytics from './components/GoogleAnalyticsWrapper';
import googleServicesApi from './network/api/googleServicesApi';

const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const enhancer = composeEnhancers(applyMiddleware(thunk));

export const store = createStore(
  reducers,
  // eslint-disable-next-line no-underscore-dangle
  enhancer,
);

syncTranslationWithStore(store);
store.dispatch(loadTranslations({
  en,
}));
store.dispatch(setLocale('en'));

function wrapApp(RootComponent, reduxStore) {
  return (
    <Provider store={reduxStore}>
      <BrowserRouter basename="/">
        <Switch>
          <PrivateRoute path="/" component={RootComponent} />
        </Switch>
      </BrowserRouter>
    </Provider>
  );
}

ReactDOM.render(
  wrapApp(
    googleAnalytics(
      App,
      googleServicesApi.fetchGAUuid()
        .then(resp => resp.json())
        .then(json => json.token),
    ),
    store,
  ),
  // $FlowFixMe
  document.getElementById('root'),
);
